import {apiFetch} from 'src/api/fetch'

import {type RentalReport, rentalReportSchema} from './schemas'

export async function getRentalReport(startDate: string, endDate: string): Promise<RentalReport> {
    const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
    })
    const raw = await apiFetch<unknown>(`/reports/first-party-deployments?${params.toString()}`)
    return rentalReportSchema.parse(raw)
}
